import { type GA4EventName, GA4FeatureCategory, trackAnalyticsEvent } from '@jsmdg/tracking';
import { type Product } from '../../../shared/types/searchResponse';

const getPrimaryImage = (product: Product) => product.images[0];

const trackSwitchMotif = async (clickElement: string, clickType: string): Promise<void> => {
    await window.yieldToMainThread();
    trackAnalyticsEvent({
        eventData: {
            eventName: 'switch_motif' as GA4EventName,
            feature_category: GA4FeatureCategory.ProductList,
            click_element: clickElement,
            click_type: clickType,
        },
    });
};

export { getPrimaryImage, trackSwitchMotif };
